import React from "react";
import styled from "styled-components";
import closeIcon from "../assets/close.png";
import { usePopupHistoryClose } from "../hooks/usePopupHistoryClose";

function PopUp2Mobile({ img, close }) {
  const handleClose = usePopupHistoryClose(close)

  return (
    <Bg>
      <Container>
        <Close src={closeIcon} onClick={handleClose} />
        <Img src={img} />
      </Container>
    </Bg>
  );
}

export default PopUp2Mobile;
const Bg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 1101;
  max-width: 100%;
`;
const Close = styled.img`
  position: fixed;
  top: 78px;
  left: 17.7px;
  cursor: pointer;
  width: 17px;
  height: auto;
  z-index: 1102;
`;
const Img = styled.img`
object-fit: contain;
width: 100%;
height: 100%;
`;
